export default __webpack_public_path__ + "static/media/desktop-logo.be240e15.png";